import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import config from '../config';

function Sidebar() {
  const [userRole, setUserRole] = useState(null);
  const [openSections, setOpenSections] = useState({
    adminRoutes: false,
    systemSetup: false,
    smsManagement: false,
    dbBackup: false,
  });

  useEffect(() => {
    const fetchUserRole = async () => {
      try {
        const response = await axios.get(`${config.apiBaseUrl}/auth/me`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });
        setUserRole(response.data.role);
      } catch (error) {
        console.error('Error fetching user role:', error);
      }
    };

    fetchUserRole();
  }, []);

  const toggleSection = (section) => {
    setOpenSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  if (!userRole) return null;

  return (
    <nav className="sidebar sidebar-offcanvas" id="sidebar">
      <ul className="nav">
        {userRole === 'Admin' ? (
          <>
            {/* DB Backup Section */}
            <li className="nav-item" onClick={() => toggleSection('dbBackup')}>
              <div className="nav-link">
                <i className="ti-harddrive menu-icon"></i>
                <span className="menu-title">DB Backup</span>
                <i className="menu-arrow"></i>
              </div>
            </li>
            {openSections.dbBackup && (
              <ul className="nav flex-column sub-menu">
                <li className="nav-item">
                  <Link className="nav-link" to="/backups">Backups</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/source-databases">Source Databases</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/emails">Emails</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/smtp-config">SMTP Config</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/target-connection">Target Connection</Link>
                </li>
              </ul>
            )}

           {/* System Setup Section */}
            <li className="nav-item" onClick={() => toggleSection('systemSetup')}>
              <div className="nav-link">
                <i className="ti-settings menu-icon"></i>
                <span className="menu-title">System Setup</span>
                <i className="menu-arrow"></i>
              </div>
            </li>
            {openSections.systemSetup && (
              <ul className="nav flex-column sub-menu">
                <li className="nav-item">
                  <Link className="nav-link" to="/settings">Settings</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/users">User Management</Link>
                </li>
              </ul>
            )}
          </>
        ) : (
          // For non-admin users
          <li className="nav-item">
            <Link className="nav-link" to="/backups">
              <i className="ti-harddrive menu-icon"></i>
              <span className="menu-title">Backups</span>
            </Link>
          </li>
        )}

        {/* Logout */}
        <li className="nav-item">
          <Link className="nav-link" to="/logout">
            <i className="ti-power-off menu-icon"></i>
            <span className="menu-title">Logout</span>
          </Link>
        </li>
      </ul>
    </nav>
  );
}

export default Sidebar;
